import { component } from "preact";
import { css } from "emotion";

import P from "./P";

const TickBlock = ({
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  maxWidth = "none",
  mobileMaxWidth = "none",
  list,
  children
}) => {
  const tick = require("../../assets/ic_tick.svg");

  const styleObj = {
    paddingLeft: 32,
    backgroundImage: `url(${tick})`,
    backgroundRepeat: "no-repeat",
    backgroundPositionX: 2,
    minHeight: 24,
    marginBottom: marginBottom,
    marginTop: marginTop
  };

  styleObj[`@media(max-width:${breakpoint}px)`] = {
    marginTop: marginTopMobile,
    marginBottom: marginBottomMobile
  };

  const style = css(styleObj);

  return (
    <div className={style} role={list ? "listitem" : ""}>
      <P>{children}</P>
    </div>
  );
};

export default TickBlock;
